import { consentChanged, getConsentForGV } from "@otto-ec/eprivacy-cmp";
import { captureError } from "@otto-ec/global-resources/apm";
import { defaultApmLabels } from "@kestrel/bundle-metadata";
import { isPrivacyPage } from "@otto-ec/global-resources/misc";
import type { UnifiedSDKConfig } from "@otto-ec/otto-vendor-verint/types";

export const BLACKLIST = [
  /^\/order(?!\/(?:confirmation|checkout)(?:\/|$))(?:\/|$)/,
  /^\/payment-selection(?:\/|$)/,
  /^\/payment-mandates(?:\/|$)/,
  /^\/dad-date(?:\/|$)/,
  /^\/dad-view(?:\/|$)/,
  /^\/customer-registration(?:\/|$)/,
];

export const isPathBlacklisted = (pathname: string): boolean =>
  BLACKLIST.some((regex) => regex.test(pathname));

const init = async (): Promise<void> => {
  /*                  */
  const { unifiedSDK: initCheck } = window;

  if (initCheck) {
    return;
  }

  const currentPathname = window.location.pathname;

  /*                                             */
  if (
    !import.meta.env.DEV &&
    (!window.o_util.toggle.get("verint_enable_xmsdk", true) ||
      isPrivacyPage() ||
      !(await getConsentForGV("POLMG")) ||
      isPathBlacklisted(currentPathname))
  ) {
    return;
  }

  const containerCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("uws_container_override="));

  const containerValue =
    containerCookie && JSON.parse(decodeURIComponent(containerCookie.split("=")[1] as string));

  const config: UnifiedSDKConfig = {
    moduleHost: import.meta.env.VITE_VERINT_MODULE_HOST,
    configHost: import.meta.env.VITE_VERINT_CONFIG_HOST,
    modulePath: `${import.meta.env.VITE_VERINT_MODULE_PREFIX}${import.meta.env.BASE_URL}${import.meta.env.VITE_VERINT_SOURCE_HASH}/modules/{file}`,
    customAssetPath: `${import.meta.env.VITE_VERINT_MODULE_PREFIX}${import.meta.env.BASE_URL}${import.meta.env.VITE_VERINT_SOURCE_HASH}/custom/{file}`,
    siteKey: import.meta.env.VITE_VERINT_SITE_KEY,
    container: import.meta.env.VITE_VERINT_CONTAINER,
    loadTime: Date.now(),
  };

  config.container = containerValue || config.container;
  config.loadTime = Date.now();

  try {
    const sdkPath = `${import.meta.env.BASE_URL}${import.meta.env.VITE_VERINT_SOURCE_HASH}/modules/sdk.js`;
    await import(/*             */ sdkPath);

    const readyCallbacks: never[] = [];
    window.uwsReady = (callback) => readyCallbacks.push(callback);

    /*                                                             */
    window.unifiedSDK!.start(config, readyCallbacks);
  } catch (e) {
    captureError(e as Error, defaultApmLabels, { type: "VerintRuntimeError" });
  }
};

consentChanged.sub(init);
export default init();
